import React from 'react'
import { useNavigate } from 'react-router-dom';
import logOut from '../images/logout.png'
import menu from '../images/app.png'

const NavBar = ({onSideBar}) => {
  const navigate=useNavigate()
  const logout=()=>{
    sessionStorage.removeItem('clientId');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('locations');
    sessionStorage.removeItem('adminInfo');
    sessionStorage.removeItem('userType');
    sessionStorage.removeItem('clientSettings');
    sessionStorage.removeItem('hasShownMultipleLocationModal');
    sessionStorage.removeItem('selectedLocation');
    window.location.reload();
    navigate('/login');
  }
  return (
    <div><header className="flex justify-between items-center mb-6">
    <button onClick={onSideBar} className=" text-gray-600">
      <img src={menu} className='w-10 h-10'  alt="" />
    </button>
    <h1 className="text-xl font-bold text-gray-800 font-QBold">Dashboard</h1>
    <div onClick={logout} className="w-10 h-10 rounded-full flex justify-center items-center bg-white overflow-hidden">
      <img src={logOut} className='w-6 h-6'  alt="" />
      
    </div>
  </header></div>
  )
}

export default NavBar